import { Loader2Icon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { cn } from "@/shared/lib"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  const { t } = useTranslation("common")

  return (
    // Verdant's spinner turns in 0.7s, not the 1s Tailwind default. The glyph
    // is still lucide's — swap it for the Verdant ring when the icon set lands.
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label={t('ui.loading')}
      className={cn("size-icon-md animate-spinner", className)}
      {...props}
    />
  )
}

export { Spinner }
